import React, { useContext, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import {
  TextField,
  MenuItem,
  Box,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { WorkoutContext } from "./provider/WorkoutProvider";

ChartJS.register(ArcElement, Tooltip, Legend);

const CategoryChart = ({ monthlyTransactions }) => {
  const [selectedCategory, setSelectedCategory] = useState("upperBody");
  const { isLoadingWorkouts } = useContext(WorkoutContext);
  const theme = useTheme();

  const handleChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const categorySums = monthlyTransactions
    .filter((transaction) => transaction.category === selectedCategory)
    .reduce((acc, transaction) => {
      if (!acc[transaction.exercise]) {
        acc[transaction.exercise] = 0;
      }
      acc[transaction.exercise] += transaction.total_score;

      return acc;
    }, {});

  const categoryLabels = Object.keys(categorySums);
  const categoryValues = Object.values(categorySums);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
  };

  const upperBodyExerciseColor = {
    サイドレイズ: theme.palette.upperBodyExerciseColor.サイドレイズ,
    アームカール: theme.palette.upperBodyExerciseColor.アームカール,
    ベンチプレス: theme.palette.upperBodyExerciseColor.ベンチプレス,
    チンニング: theme.palette.upperBodyExerciseColor.チンニング,
    ベントオーバーロウ: theme.palette.upperBodyExerciseColor.ベントオーバーロウ,
  };

  const lowerBodyExerciseColor = {
    スクワット: theme.palette.lowerBodyExerciseColor.スクワット,
    デッドリフト: theme.palette.lowerBodyExerciseColor.デッドリフト,
  };

  const cardioExerciseColor = {
    スイミング: theme.palette.cardioExerciseColor.スイミング,
    ランニング: theme.palette.cardioExerciseColor.ランニング,
  };

  const getCategoryColor = (exercise) => {
    if (selectedCategory === "upperBody") {
      return upperBodyExerciseColor[exercise];
    } else if (selectedCategory === "lowerBody") {
      return lowerBodyExerciseColor[exercise];
    } else {
      return cardioExerciseColor[exercise];
    }
  };

  const data = {
    labels: categoryLabels,
    datasets: [
      {
        data: categoryValues,
        backgroundColor: categoryLabels.map((exercise) => {
          return getCategoryColor(exercise);
        }),
        // [
        //   "rgba(255, 99, 132, 0.2)",
        //   "rgba(54, 162, 235, 0.2)",
        //   "rgba(255, 206, 86, 0.2)",
        //   "rgba(75, 192, 192, 0.2)",
        //   "rgba(153, 102, 255, 0.2)",
        //   "rgba(255, 159, 64, 0.2)",
        // ],
        borderColor: categoryLabels.map((exercise) => {
          return getCategoryColor(exercise);
        }),
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <TextField
        select
        fullWidth
        value={selectedCategory}
        onChange={handleChange}
      >
        <MenuItem value={"upperBody"}>上半身</MenuItem>
        <MenuItem value={"lowerBody"}>下半身</MenuItem>
        <MenuItem value={"cardio"}>有酸素運動</MenuItem>
      </TextField>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isLoadingWorkouts ? (
          <CircularProgress aria-label="Loading…" />
        ) : monthlyTransactions.length > 0 ? (
          <Pie data={data} options={options} />
        ) : (
          <Typography>データがありません</Typography>
        )}
      </Box>
    </>
  );
};

export default CategoryChart;
